import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { getHostDomain } from 'frontend-utils/utils/domain-checks';
import ENV from 'lumen/config/environment';
import type HotelSettingsSecurityRoute from 'lumen/routes/hotel/settings/security';
import type { ModelFrom } from 'lumen/utils/routes';

export default class HotelSettingsSecurityController extends Controller {
  declare model: ModelFrom<HotelSettingsSecurityRoute>;

  // eslint-disable-next-line ember/no-unused-services
  @service declare access: Services['access'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get areConfigsLoading() {
    return this.model.mfaConfigsTask?.isRunning;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get mfaConfigs() {
    if (this.areConfigsLoading || !this.model.mfaConfigsTask?.last?.value) {
      return [];
    }

    return this.model.mfaConfigsTask.lastSuccessful?.value ?? [];
  }

  @action redirectToChangePassword(): void {
    window.location.href = `${getHostDomain({ frontendGateway: ENV.frontendGateway })}/password-reset`;
  }

  @action refreshMfaConfigs(): void {
    this.send('refreshModel');
  }
}
